import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IQueryParams, IService } from '../../../models/index';
import { serviceListResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import { getAllServices } from '../../actions/actionType/services/ServiceActionTypes';
import {
  getAllServiceFailure,
  getAllServiceStarted,
  getAllServiceSuccess
} from '../../actions/sagaActions/services/GetAllServiceAction';
import { IGetAllServiceFailurePayload, IGetAllServiceRequest } from '../../actions/types/services/GetAllServiceTypes';

/**
 * Call Gets Service Events by API
 * @returns api response
 */
export async function callGetAllServiceApi(pageNo: number, item: number, queryParams?: IQueryParams, sort?: string) {
  const urlString = `${process.env.REACT_APP_API_CONTROL_PLANE_GET_ALL_SERVICE}/services/search?page=${pageNo}&size=${item}&sort=${sort || 'updatedTimestamp,DESC'}`;
  const requestBody = queryParams ? {
    services: queryParams.searchText ? [{
      serviceName: queryParams.searchText
    }] : undefined,
    exactNameMatch: false,
    status: queryParams.status === '' ? undefined : queryParams.status?.split(','),
    fromDate: queryParams.fromDate ? (queryParams.fromDate) : undefined,
    toDate: queryParams.toDate ? (queryParams.toDate) : undefined,
  } : {};
  const resp = await apiWrapper.post<IService, { errorMessage: string }
  >(
    urlString,
    requestBody,
    headersInstance()
  );

  const apiResponse = serviceListResponseSchema.validate(resp.responseBody, {
    abortEarly: true
  });

  if (resp.isError || !apiResponse.value) {
    return {
      errorMessage: resp.errorBody?.errorMessage,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }
  const serviceRecords = resp.responseBody;
  return {
    serviceRecords,
    isError: resp.isError,
    statusCode: resp.statusCode
  };
}

export function* getAllService({ pageNo, item, queryParams, sort }: IGetAllServiceRequest) {
  yield put(getAllServiceStarted());
  try {
    const { serviceRecords, errorMessage } = yield call(callGetAllServiceApi, pageNo, item, queryParams, sort);
    if (serviceRecords) {
      yield put(getAllServiceSuccess(serviceRecords));
    } else {
      throw new Error(errorMessage);
    }
  } catch (error) {
    const obj: IGetAllServiceFailurePayload = {
      error: String(error)
    };
    yield put(getAllServiceFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchAllServiceSaga() {
  yield takeLatest(getAllServices.FETCH_ALL_SERVICE_REQUEST, getAllService);
}

export const getAllServiceSaga = [fork(fetchAllServiceSaga)];
